module.exports = __webpack_public_path__ + "img/Top-Users-by-Centrality-Rank-300x187.7a65fe69.png";